import { Instagram, Linkedin, Facebook, AtSign } from "lucide-react";
import { SOCIAL_LINKS } from "../../data/config";

const TikTokIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64c.3 0 .6.05.88.13V9.4a6.33 6.33 0 0 0-1-.05A6.34 6.34 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

const SpotifyIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" className={className} aria-hidden="true">
    <circle cx="12" cy="12" r="10" />
    <path d="M8 10.2c2.7-.9 5.8-.7 8.3.8" />
    <path d="M8.5 13.3c2.2-.7 4.5-.5 6.4.6" />
    <path d="M9 16.1c1.6-.4 3.2-.3 4.6.4" />
  </svg>
);

const LinktreeIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M13.5 2h-3v6.6L6.6 4.7 4.7 6.6l3.9 3.9H2v3h6.6l-3.9 3.9 1.9 1.9 3.9-3.9V22h3v-6.6l3.9 3.9 1.9-1.9-3.9-3.9H22v-3h-6.6l3.9-3.9-1.9-1.9-3.9 3.9z" />
  </svg>
);

const ICONS = {
  tiktok: TikTokIcon,
  instagram: Instagram,
  linkedin: Linkedin,
  facebook: Facebook,
  threads: AtSign,
  spotify: SpotifyIcon,
  linktree: LinktreeIcon,
};

export const SocialIcons = ({ className = "", iconClassName = "h-4 w-4" }) => (
  <div className={`flex items-center gap-5 ${className}`}>
    {SOCIAL_LINKS.map((s) => {
      const Icon = ICONS[s.id];
      return (
        <a
          key={s.id}
          href={s.url || "#"}
          target={s.url ? "_blank" : undefined}
          rel="noreferrer"
          aria-label={s.label}
          data-testid={`social-link-${s.id}`}
          className="opacity-70 transition-opacity duration-300 hover:opacity-100"
        >
          <Icon className={iconClassName} strokeWidth={1.5} />
        </a>
      );
    })}
  </div>
);
